
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"8","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.41.406c.262-.25.617-.39.988-.39.37 0 .726.14.989.39L6.99 4.788 11.596.406c.129-.127.283-.228.454-.298a1.46 1.46 0 011.54.282c.132.125.236.273.306.437a1.273 1.273 0 01-.01 1.029 1.33 1.33 0 01-.313.432L7.98 7.61c-.262.25-.618.39-.989.39-.37 0-.726-.14-.988-.39L.409 2.288A1.299 1.299 0 010 1.347C0 .994.147.656.41.407z"}})])
          )
        }
      }
    